// extracted by mini-css-extract-plugin
export default {"placeholder":"kkEjnf18","dropdownStyle":"c_74_p5m","MuiList-root":"TPC6qnLp","MuiMenuItem-root":"TjAqRQf6"};